import { Button } from '../Button'
import { StyleFn } from '..'

export const IconButton: StyleFn = (theme) => {
  const {
    size: { spacing },
  } = theme
  const { root, _ghost, _primary, _secondary, _success, _warning, _error } = Button(theme)

  return {
    root: {
      ...root,
      minWidth: spacing[40],
      padding: `calc(${spacing[8]} - 1px)`,
      '& svg, & i': {
        margin: 0,
        width: spacing[24],
        height: spacing[24],
        fontSize: spacing[24],
        fill: 'currentColor',
        display: 'inline-flex',
      },
    },
    _ghost,
    _primary,
    _secondary,
    _success,
    _warning,
    _error,
    _xsmall: {
      minWidth: spacing[24],
      height: spacing[24],
      padding: spacing[2],
      '& svg, & i': {
        width: spacing[16],
        height: spacing[16],
        fontSize: spacing[16],
      },
    },
    _small: {
      minWidth: spacing[32],
      minHeight: spacing[32],
      padding: `calc(${spacing[4]} + 1px)`,
      '& svg, & i': {
        width: spacing[20],
        height: spacing[20],
        fontSize: spacing[20],
      },
    },
    _medium: {},
    _large: {
      minWidth: spacing[48],
      minHeight: spacing[48],
      padding: `calc(${spacing[8]} - 1px)`,
      '& svg, & i': {
        width: spacing[32],
        height: spacing[32],
        fontSize: spacing[32],
      },
    },
  }
}
